import { RootState } from '../store'

export const citiesSelector = (state: RootState) => {
  const { cities } = state

  return cities
}
